import * as _ from "lodash";
import { Action } from "redux";

import { State } from "../model/State";

import * as FetchActions from "../actions/FetchActions";
import * as ProcessListActions from "../actions/ProcessListActions";

export function availableTags(state: string[] = [], action: Action) {
    switch (action.type) {
        case FetchActions.RECEIVE_AVAILABLE_TAGS:
            const receiveAction = action as FetchActions.ReceiveAvailableTagsAction;
            return receiveAction.tags;
        case ProcessListActions.ADD_TAGS:
            const addTagsAction = action as ProcessListActions.AddTagsAction;
            return _.unionBy(state, addTagsAction.tags, (val) => val.toLowerCase());
        default:
            return state;
    }
}
